import { BodyCopy, Header, LayoutContainer, Table } from '@greystar/designsystem';
import { Text as JssText, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { TableRow } from '../../component-props';

// Assuming the table data headers and rows are passed down as props
const tableHeaders = [
  { key: 'ITEM_1', header: '' },
  { key: 'ITEM_2', header: '' },
];

interface FeesTableProps {
  fees: TableRow[];
  header?: TextField;
  description?: string;
  toolTipClick?: (label: string) => void;
}

const FeesTable = ({ fees, header, description, toolTipClick }: FeesTableProps) => {
  return (
    <div data-testid="fees-table" className="[&_.table-line]:!relative [&_.table-line]:!top-[1px]">
      {header && (
        <LayoutContainer paddingBottom="sm">
          <Header component="h6" as="h4">
            <JssText field={header} />
          </Header>
        </LayoutContainer>
      )}
      {description && <BodyCopy>{description}</BodyCopy>}
      <Table columns={tableHeaders} rows={fees} col={2} row={5} toolTipClick={toolTipClick} />
    </div>
  );
};

export default FeesTable;
